import { FlagsPermissionPickup } from "@/feature-flags/flag-pickup";
import { FlagsPermissionHorde } from "@/feature-flags";
const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");

const SchedulePickupList = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/pickup/schedule/list/index.vue"
  );

const SchedulePickupDetail = () =>
  import(
    /* webpackChunkName: "Detail" */ "@/app/ui/views/pickup/schedule/detail/index.vue"
  );

const SchedulePickupForm = () =>
  import(
    /* webpackChunkName: "Form" */ "@/app/ui/views/pickup/components/schedule-config-form/index.vue"
  );

const PickupScheduleConfig = () =>
  import(
    /* webpackChunkName: "Form" */ "@/app/ui/views/pickup/pickup-schedule-config/index.vue"
  );

const PickupList = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/pickup/list-pickup/list/index.vue"
  );

const PickupListv2 = () =>
  import(
    /* webpackChunkName: "STTBookingV2" */ "@/app/ui/views/pickup/list-pickup-v2/list/index.vue"
  );

const PickupDetailV2 = () =>
  import(
    /* webpackChunkName: "DetailV2" */ "@/app/ui/views/pickup/list-pickup-v2/detail/index.vue"
  );

const PickupDetail = () =>
  import(
    /* webpackChunkName: "Detail" */ "@/app/ui/views/pickup/list-pickup/detail/index.vue"
  );

const PickupForm = () =>
  import(
    /* webpackChunkName: "Form" */ "@/app/ui/views/pickup/components/pickup-form/index.vue"
  );

export default [
  {
    path: "/pickup",
    component: Layout,
    name: "pickup-schedule",
    redirect: "/pickup/schedule-list",
    meta: {
      icon: "pickup-manifest",
      children: true,
      title: "pickupCorporate.menuPickUp",
      name: "pickupCorporate.menuPickUp",
      permission: [
        FlagsPermissionPickup.permission_pickup_scheduled_pickup_enable
      ]
    },
    children: [
      {
        path: "list-pickup",
        name: "list-pickup",
        component: PickupList,
        meta: {
          header: true,
          icon: "clipboard-check",
          title: "Daftar Pick Up",
          name: "Daftar Pick Up",
          hadSameName: true,
          permission: FlagsPermissionPickup.permission_pickup_enable
        }
      },
      {
        path: "list-pickup-v2",
        name: "list-pickup-v2",
        component: PickupListv2,
        meta: {
          header: true,
          icon: "clipboard-check",
          title: "pickupV2.list.title",
          name: "pickupV2.list.title",
          hadSameName: true,
          permission: FlagsPermissionPickup.permission_pickup_enable_v2,
          noPaddingWithBreadcrumbV2: true,
          layoutNoPadding: true
        }
      },
      {
        path: "schedule-list",
        name: "schedule-list",
        component: SchedulePickupList,
        meta: {
          header: true,
          icon: "pickup-schedule-list",
          title: "pickupCorporate.menuScheduleConfig",
          name: "pickupCorporate.menuScheduleConfig",
          permission:
            FlagsPermissionPickup.permission_pickup_scheduled_pickup_enable
        }
      }
    ]
  },
  {
    path: "/pickup/scheduled-pickup",
    component: Layout,
    name: "pickup-scheduled-detail",
    meta: {
      title: "pickupCorporate.menuScheduleConfig",
      hidden: true,
      parent: "pickupCorporate.menuScheduleConfig",
      "parent-path": "/pickup/schedule-list",
      permission:
        FlagsPermissionPickup.permission_pickup_scheduled_pickup_enable
    },
    children: [
      {
        path: ":id",
        name: "pickup-scheduled-detail",
        component: SchedulePickupDetail,
        meta: {
          header: true
        }
      }
    ]
  },
  {
    path: "/pickup/scheduled-pickup",
    name: "pickup-scheduled-create",
    component: Layout,
    redirect: "/pickup/scheduled-pickup/create",
    meta: {
      hidden: true,
      title: "pickupCorporate.menuCreateConfig",
      parent: "pickupCorporate.menuScheduleConfig",
      "parent-path": "/pickup/schedule-list",
      permission:
        FlagsPermissionPickup.permission_pickup_scheduled_pickup_create
    },
    children: [
      {
        path: "create",
        name: "pickup-scheduled-create",
        component: SchedulePickupForm,
        meta: {
          header: true,
          name: "pickupCorporate.menuCreateConfig",
          before: "/pickup/schedule/list"
        }
      }
    ]
  },
  {
    path: "/pickup/scheduled-pickup",
    name: "pickup-scheduled-edit",
    redirect: "/pickup/scheduled-pickup/edit",
    component: Layout,
    meta: {
      hidden: true,
      title: "pickupCorporate.menuEditConfig",
      parent: "pickupCorporate.menuScheduleConfig",
      "parent-path": "/pickup/schedule-list",
      permission: FlagsPermissionPickup.permission_pickup_scheduled_pickup_edit
    },
    children: [
      {
        path: ":id/edit",
        name: "pickup-scheduled-edit",
        component: SchedulePickupForm,
        meta: {
          header: true,
          name: "pickupCorporate.menuEditConfig",
          before: "/pickup/scheduled-pickup/:id"
        }
      }
    ]
  },
  {
    path: "/pickup/list-pickup",
    component: Layout,
    name: "pickup-detail",
    meta: {
      title: "pickupCorporate.menuListPickUp",
      hidden: true,
      parent: "pickupCorporate.menuListPickUp",
      "parent-path": "/pickup/list-pickup",
      permission: FlagsPermissionPickup.permission_pickup_enable
    },
    children: [
      {
        path: ":id",
        name: "pickup-detail",
        component: PickupDetail,
        meta: {
          header: true
        }
      }
    ]
  },
  {
    path: "/pickup/list-pickup-v2",
    component: Layout,
    name: "pickup-detail-v2",
    meta: {
      title: "pickupV2.detail.pageTitle",
      hidden: true,
      parent: "pickupV2.list.title",
      "parent-path": "/pickup/list-pickup-v2",
      permission: FlagsPermissionPickup.permission_pickup_enable_v2
    },
    children: [
      {
        path: ":id",
        name: "pickup-detail-v2",
        component: PickupDetailV2,
        meta: {
          header: true
        }
      }
    ]
  },
  {
    path: "/pickup/list-pickup",
    name: "pickup-create",
    component: Layout,
    redirect: "/pickup/list-pickup/create",
    meta: {
      hidden: true,
      title: "pickupCorporate.menuCreatePickUp",
      parent: "pickupCorporate.menuListPickUp",
      "parent-path": "/pickup/list-pickup",
      permission: FlagsPermissionPickup.permission_pickup_list_pickup_create
    },
    children: [
      {
        path: "create",
        name: "pickup-list-create",
        component: PickupForm,
        meta: {
          header: true,
          title: "Pickup | Create ",
          name: "pickupCorporate.menuCreatePickUp",
          before: "/pickup/list-pickup",
          formType: "manual"
        }
      }
    ]
  },
  {
    path: "/pickup/pickup-schedule-config",
    component: Layout,
    beforeEnter: () => {
      return FlagsPermissionHorde.dhl_first_mile_client_whitelist.isEnabled()
        ? "/not-found"
        : true;
    },
    meta: {
      hidden: true,
      title: "pickup.scheduleConfig.pageTitle",
      parent: "pickup.scheduleConfig.breadcrumb.parent",
      "parent-path": "/pickup/list-pickup-v2",
      permission:
        FlagsPermissionPickup.permission_pickup_scheduled_pickup_enable
    },
    children: [
      {
        path: "",
        name: "pickup-schedule-config",
        component: PickupScheduleConfig,
        meta: {
          header: true,
          name: "pickup.scheduleConfig.pageTitle",
          title: "pickup.scheduleConfig.pageTitle",
          before: "/pickup/list-pickup-v2"
        }
      }
    ]
  }
];
